import { MenuFavorite } from "@dashboard/types";
import { type ReduxState } from "@dashboard/types/reduxState";

export type MenuFavoritesReducerAction =
  | { type: "UPDATE_MENU_FAVORITE"; payload: MenuFavorite }
  | { type: "FETCHED_MENU_FAVORITES"; payload: MenuFavorite[] };

export const menuFavoritesReducer: (
  state: ReduxState["menuFavorites"] | undefined,
  action: MenuFavoritesReducerAction
) => ReduxState["menuFavorites"] = (
  state: ReduxState["menuFavorites"] = {
    initialMenuFavoritesLoading: true,
    menuFavorites: [],
  },
  action: MenuFavoritesReducerAction
) => {
  switch (action.type) {
    case "UPDATE_MENU_FAVORITE":
      return {
        ...state,
        menuFavorites: [
          ...state.menuFavorites.filter(
            (menuFavorite) => menuFavorite.id !== action.payload.id
          ),
          action.payload,
        ],
      };

    case "FETCHED_MENU_FAVORITES":
      return {
        ...state,
        initialLocationsLoading: false,
        menuFavorites: action.payload, // ordering is done in the action
      };
    default:
      return state;
  }
};
